import File from '@/components/DesignLibrary/File';
import CustomSelect from '@/components/FormFields/CustomSelect';
import { FC, useState } from 'react';
import CaretDown from '@/components/Icons/CaretDown';
import ArrowUp from '@/components/Icons/ArrowUp';
import ArrowDown from '@/components/Icons/ArrowDown';
import Buttons from '@/components/Buttons';
import classNames from 'classnames';

import s from './DocumentSort.module.scss';

const DocumentSort: FC<{
  setFiles: (files: Array<Parameters<typeof File>[0]['document']>) => void;
  files: Parameters<typeof File>[0]['document'][];
  className?: string;
}> = ({ setFiles, files, className }) => {
  const [isDescending, setIsDescending] = useState(true);
  const [sortField, setSortField] = useState<'date' | 'name'>('date');

  const sortFiles = (field: 'date' | 'name', order: boolean): void => {
    let sorted;
    if (field === 'date') {
      sorted = [...files].sort(
        (a, b) =>
          order
            ? new Date(a.uploadedAt).getTime() - new Date(b.uploadedAt).getTime()
            : new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime(),
      );
    } else {
      sorted = [...files].sort(
        (a, b) =>
          order
            ? a.fileName.localeCompare(b.fileName)
            : b.fileName.localeCompare(a.fileName),
      );
    }
    setFiles(sorted);
  };

  const handleSortChange = (field: 'date' | 'name'): void => {
    setSortField(field);
    sortFiles(field, isDescending);
  };

  const handleOrderToggle = (): void => {
    const newOrder = !isDescending;
    setIsDescending(newOrder);
    sortFiles(sortField, newOrder);
  };

  return (
    <div className={classNames(s.wrapper, className)}>
      <CustomSelect
        id="sort-by"
        value=""
        trigger={
          <p className="caption">
            Sort by <CaretDown size={10} />
          </p>
        }
        options={[
          {
            title: 'Upload date',
            value: 'date',
          },
          {
            title: 'File name',
            value: 'name',
          },
        ]}
        onChange={(value: string) => {
          handleSortChange(value as 'date' | 'name');
        }}
      />
      <Buttons isWrapper onClick={handleOrderToggle} className='caption'>
        {isDescending ? <><ArrowDown />Desc</> : <><ArrowUp />Asc</>}
      </Buttons>
    </div>
  );
};

export default DocumentSort;
